import React from 'react';
import { Alert } from '@mui/material';
import { AccountTree } from '@mui/icons-material';
import WorkflowsGrid from './WorkflowsGrid';
import { WorkflowListItem } from '../../../../services/WorkflowService';
import { LoadingIndicator } from '../../../common/components/styled-ui-elements';

interface WorkflowListContentProps {
  workflows: WorkflowListItem[];
  isLoading: boolean;
  isError: boolean;
  onView: (id: string) => void;
  onActivateToggle: (id: string, isActive: boolean) => void;
  onDelete: (id: string) => void;
}

const WorkflowListContent: React.FC<WorkflowListContentProps> = ({
  workflows,
  isLoading,
  isError,
  onView,
  onActivateToggle,
  onDelete,
}) => {
  if (isLoading) {
    return <LoadingIndicator icon={AccountTree} message="Loading workflows..." minHeight="300px" />;
  }

  if (isError) {
    return (
      <Alert severity="error" sx={{ mb: 2 }}>
        Failed to load workflows. Please try again.
      </Alert>
    );
  }

  return (
    <WorkflowsGrid
      workflows={workflows}
      onView={onView}
      onActivateToggle={onActivateToggle}
      onDelete={onDelete}
      isLoading={isLoading}
    />
  );
};

export default WorkflowListContent;
